export default{
headtableData:[
	{
		title: "选择",
		prop: "xz",
		width:"100px",
		custom:true
	},
	{
		title: "公司科目编码",
		prop: "companySubjectCode",
		width:"200px"
	},
	{
		title: "公司科目名称",
		prop: "companySubjectName",
		width:"200px"
	}
],
pagination: {
		pageNum: 1,
		pageSize: 50,
		total: 0,
		paginationkey:0
	},
}